import type { Entry } from 'contentful';

import { TypeOpcoSkeleton } from '../models/cms';
import { Image, OpCoData } from '../models';

import { transformMarket } from './transformMarket';
import { transformLocale } from './transformLocale';
import { transformUIStrings } from './transformUIStrings';

export const transformOpCo = (skeleton: Entry<TypeOpcoSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>): OpCoData => {
  if (!skeleton.fields.image) {
    throw new Error(`Expected an image in opco: '${skeleton.sys.id}'`);
  }

  if (!skeleton.fields.uiStrings) {
    throw new Error(`Expected UI Strings in opco: '${skeleton.sys.id}'`);
  }

  const image = {
    title: skeleton.fields.image?.fields.title,
    description: skeleton.fields.image?.fields.description,
    url: skeleton.fields.image?.fields.file?.url,
  } as Image;

  const markets = skeleton.fields.markets.filter((x) => !!x).map(transformMarket);

  if (markets.length === 0) {
    throw new Error(`Expected at least 1 market in opco: '${skeleton.sys.id}'`);
  }

  const locales = skeleton.fields.locales.filter((x) => !!x).map(transformLocale);

  if (locales.length === 0) {
    throw new Error(`Expected at least 1 locale in opco: '${skeleton.sys.id}'`);
  }

  return {
    id: skeleton.fields.id,
    image,
    label: skeleton.fields.label,
    markets,
    locales,
    hasMegaNav: skeleton.fields.hasMegaNav,
    uiStrings: transformUIStrings(skeleton.fields.uiStrings),
  };
};
